import React, { useState } from "react";
import { Card, GridLegacy, MenuItem, Typography } from "@mui/material";
import CardBody from "../../../components/Card/CardBody";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import AuthenticationWrapper from "../../../auth/AuthenticationWrapper";
import Checkbox from "@mui/material/Checkbox";
import { FilterRibbon } from "../../../components/FilterRibbon/FilterRibbon";
import { ImageResolutionHint } from "../../../components/ImageHints/ImageResolutionHint";
import FormFile from "../../../components/Forms/FormFile";
import { useWatch } from "react-hook-form";
import { namedJamezzFiles, ribbonComponents } from "./V5/QrV5";
import Box from "@mui/material/Box";

function PickupDelivery() {
  const [selectedGroupVal, setSelectedGroupVal] = useState("none");
  const [showAdminValues, setShowAdminValues] = useState(false);

  const toggleAdminMode = () => {
    setShowAdminValues(!showAdminValues);
  };

  const changeSelector = (newSelector) => {
    setSelectedGroupVal(newSelector);
  };

  const translatedAdminEditMode = getTranslation("QrV5_SortingRibbon.Admin_edit_mode", "not found");

  const listOfInactiveAreas = translatedAdminEditMode.slice(
    translatedAdminEditMode.indexOf("["),
    translatedAdminEditMode.lastIndexOf("]") + 1
  );

  const translatedAdminEditModeText = translatedAdminEditMode.replace(listOfInactiveAreas, "");
  const mediaUrls = useWatch({ name: "media_urls" });
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
      <Card sx={{ maxWidth: 800 }}>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy item xs={12}>
            <h3>
              <TranslationWrapper
                tDefault={"Pickup delivery webshop settings"}
                tKey={"vestigingen.form.algemeen.headers.pickupDeliveryWebshopSettings"}
              />
            </h3>
          </GridLegacy>
          <FormSelectTC
            name={"custom_data.webshop_type"}
            options={[
              <MenuItem key={"takeaway"} value={"2"}>
                Takeaway
              </MenuItem>,
              <MenuItem key={"delivery"} value={"1"}>
                Delivery
              </MenuItem>,
            ]}
            rules={{ required: { value: true, message: "Required!" } }}
            tKey={"custom_data.webshop_type"}
          />

          <FormTextTC
            name={"instoreAfterOrderUrl"}
            tDefault={"Url after order"}
            tKey={"vestigingen.form.zuil.label.instoreAfterOrderUrl"}
          />
          <FormControlledInputTC
            name={"afterOrderTimeout"}
            rules={{
              min: {
                value: 0,
                message: <TranslationWrapper tKey={"The value must not be negative!"} />,
              },
            }}
            tDefault={"Url after order timeout"}
            tKey={"vestigingen.form.zuil.label.afterOrderTimeout"}
            type={"number"}
          />
          <FormSwitchTC
            name={"genQRCode"}
            tDefault={"Generate QR"}
            tKey={"vestigingen.form.algemeen.label.genQRCode"}
          />
          <FormSwitchTC name={"use_packagings"} tDefault={"Use Packagings"} tKey={"use_packagings"} />
        </CardBody>
      </Card>

      <Card sx={{ maxWidth: 800 }}>
        <CardBody>
          <GridLegacy item xs={12}>
            <h3>
              <TranslationWrapper tDefault={"Limieten"} tKey={"vestigingen.form.algemeen.headers.limieten"} />
            </h3>
          </GridLegacy>
          <FormSwitchTC
            name={"orderLimits"}
            tDefault={"Order limieten gebruiken"}
            tKey={"vestigingen.form.overige.label.orderLimits"}
          />
          <FormControlledInputTC
            name={"minOrderValue"}
            tDefault={"Min order value"}
            tKey={"vestigingen.form.overige.label.minOrderValue"}
            type={"currency"}
          />
          <FormControlledInputTC
            name={"maxOrderValue"}
            tDefault={"Max order value"}
            tKey={"vestigingen.form.overige.label.maxOrderValue"}
            type={"currency"}
          />
        </CardBody>
      </Card>

      <Card sx={{ maxWidth: 1200 }}>
        <CardBody>
          <GridLegacy container>
            <GridLegacy item md={6} xs={12}>
              <h3>
                <TranslationWrapper
                  tDefault={"Webshop app images"}
                  tKey={"vestigingen.form.algemeen.headers.webshop.images"}
                />
              </h3>
            </GridLegacy>

            <AuthenticationWrapper
              child={(write) => (
                <GridLegacy
                  item
                  md={6}
                  style={{ marginBottom: 10, marginTop: 15, display: "flex", alignItems: "center" }}
                  xs={12}
                >
                  <Checkbox
                    checked={showAdminValues}
                    color={"primary"}
                    onChange={toggleAdminMode}
                    size={"small"}
                    style={{ width: 50, height: 50 }}
                  />

                  {showAdminValues || listOfInactiveAreas === "" ? (
                    <TranslationWrapper tDefault={"Admin edit mode"} tKey={"KioskV5_SortingRibbon.Admin_edit_mode"} />
                  ) : (
                    <Typography>{translatedAdminEditModeText}</Typography>
                  )}
                </GridLegacy>
              )}
              permissionKey={"brandingdesign.customcomponents.admineditmode"}
            />
          </GridLegacy>

          <FilterRibbon
            allSelectedFilterText={"Show all images"}
            areaHighlightBackground={"#000000"}
            areaHighlightBackgroundOpacity={175}
            areaOpacity={100}
            changeSelector={changeSelector} //** Important
            colorGroup1Background={"#f46e26"}
            colorGroup1Foreground={"#ffffff"}
            colorGroup2Background={"#ffffff"}
            colorGroup2Foreground={"#000000"}
            colorGroup3Background={"#f46e26"}
            colorGroup3Foreground={"#ffffff"}
            inactiveAreaColor={"#FF0000"}
            inactiveAreas={listOfInactiveAreas}
            ribbonComponents={ribbonComponents} //** Important
            selectedGroupVal={selectedGroupVal} //** Important
            showAdminInfo={showAdminValues}
            showBreadcrumbs={false}
            showFilterReturnButton={true}
            showHoverDescription={true}
            shownDescription={"none"} // options: side, bottom (default), none
          />

          <GridLegacy container>
            {namedJamezzFiles.map((namedJamezzFile) => {
              const translatedImageTitle = getTranslation(`vestigingen.form.zuil.label.${namedJamezzFile.name}`);

              const screenIndex = translatedImageTitle.slice(
                translatedImageTitle.indexOf("["),
                translatedImageTitle.lastIndexOf("]") + 1
              );

              const errorColor =
                showAdminValues &&
                (translatedImageTitle === "notfound" ||
                  (!translatedImageTitle.includes("[") && !translatedImageTitle.includes("[")))
                  ? { color: "red" }
                  : undefined;

              if (screenIndex.includes(selectedGroupVal) || selectedGroupVal === "none") {
                return (
                  <GridLegacy item key={namedJamezzFile.name} style={errorColor} xs={4}>
                    {showAdminValues ? (
                      <TranslationWrapper
                        tDefault={namedJamezzFile.name}
                        tKey={`vestigingen.form.zuil.label.${namedJamezzFile.name}`}
                      />
                    ) : namedJamezzFile.tKey && namedJamezzFile.tDefault ? (
                      <p style={{ margin: 0 }}>
                        <TranslationWrapper tDefault={namedJamezzFile.tDefault} tKey={namedJamezzFile.tKey} />
                      </p>
                    ) : (
                      <p style={{ margin: 0 }}>{namedJamezzFile.name}</p>
                    )}
                    <ImageResolutionHint res={namedJamezzFile.res} />
                    <FormFile
                      canCrop={false}
                      imgurl={mediaUrls?.[`extra_settings__${namedJamezzFile.name}`]?.[0]?.conversions?.optimized?.url}
                      name={namedJamezzFile.name}
                      nullable={true}
                      originalUrl={mediaUrls?.[`extra_settings__${namedJamezzFile.name}`]?.[0]?.original}
                      type={namedJamezzFile.type}
                    />
                  </GridLegacy>
                );
              }
            })}
          </GridLegacy>
        </CardBody>
      </Card>
    </Box>
  );
}

export default PickupDelivery;
